// extracted by mini-css-extract-plugin
module.exports = {"topicsContainer":"topicsTemplate_topicsContainer__1JB5i"};